module.exports = __webpack_public_path__ + "static/barber-portrait-c54aa1eccce4db2294133ae9ac1518a4.jpg";